/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "pen-b237b661--sprite",
  "use": "pen-b237b661--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"pen-b237b661--sprite\"><rect width=\"36\" height=\"36\" fill=\"#fff\" opacity=\"0\" /><g transform=\"translate(-843.603 -1058.055)\"><path d=\"M865.559,1071.258a1,1,0,0,0-1.414,0l-6.717,6.718a1.5,1.5,0,0,0,2.121,2.122l6.717-6.718a1,1,0,0,0,0-1.415Z\" fill=\"currentColor\" /><path d=\"M857.216,1081.3l-.977-.977a.5.5,0,0,0-.836.192l-.8,2.413,2.413-.8a.5.5,0,0,0,.321-.63A.508.508,0,0,0,857.216,1081.3Z\" fill=\"currentColor\" /><path d=\"M868.034,1069.492a1.5,1.5,0,0,0-2.121,0,.5.5,0,0,0,0,.707l1.414,1.414a.5.5,0,0,0,.707,0A1.5,1.5,0,0,0,868.034,1069.492Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
